import { Instance, types } from 'mobx-state-tree'

export const VehicleAvailabilityModel = types.model('VehicleAvailabilityModel', {
    id: types.identifierNumber,
    available_days: types.maybeNull(types.number),
    available_flights: types.maybeNull(types.number),
    available_flight_hours: types.maybeNull(types.number),
})
.views((self) => ({
    get availableDays(): number | null {
        return self.available_days != null ? Math.max(0, self.available_days) : null
    },
    get availableFlights(): number | null {
        return self.available_flights != null ? Math.max(0, self.available_flights) : null
    },
    get availableFlightHours(): number | null {
        return self.available_flight_hours != null ? Math.max(0, self.available_flight_hours) : null
    },
}))

export type VehicleAvailability = Instance<typeof VehicleAvailabilityModel>
